/**
 * Back to top
 */

// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import 'waypoints/lib/jquery.waypoints.min';

let scrolling = false;

// Init local scroll
$('.back-to-top').localScroll();

/**
 * handleHideOnScroll Hide or display the scroll to top element based off its position
 *
 */
function handleHideOnScroll(elem1, elem2, winY) {
  let scroll = Math.ceil(elem1.offset().top);
  let footer = Math.ceil(elem2.offset().top);
  let content = Math.ceil($('.page-content').offset().top);

  if (scroll >= footer) {
    elem1.removeClass('back-to-top--visible');
  }

  if (scroll < footer && winY >= content) {
    elem1.addClass('back-to-top--visible');
  }
}

$(window).on('scroll', function(e) {
  if (!scrolling) {
    window.requestAnimationFrame(function() {
      handleHideOnScroll($('.back-to-top'), $('.site-footer'), window.scrollY);
      scrolling = false;
    });
  }
  scrolling = true;
});

// Create waypoint for back to top button
$('.page-content').waypoint(
  direction => {
    if (direction === 'down') {
      $('.back-to-top').addClass('back-to-top--visible');
    } else if (direction === 'up') {
      $('.back-to-top').removeClass('back-to-top--visible');
    }
  },
  { offset: 0 }
);
